import { atom } from 'recoil';
import { feedData } from '../../test.data';
import { FeedItem } from '../../types/feed.types';

export const feedsState = atom<FeedItem[]>({
  key: 'FEEDS_STATE',
  default: feedData,
});
